document.addEventListener('DOMContentLoaded', function () {
    if(document.querySelector('.wp-block-image')) {
        // 1. Znajdź element o klasie .entry-content
        var entryContent = document.querySelector('.entry-content');

        // 2. Stwórz strukturę lightboxa
        var lightbox = document.createElement('div');
        lightbox.id = 'lightbox';
        lightbox.className = 'lightbox';

        var closeBtn = document.createElement('span');
        closeBtn.className = 'close';
        closeBtn.innerHTML = '&times;';

        var lightboxContent = document.createElement('div');
        lightboxContent.className = 'lightbox-content';

        var lightboxContentSmallDIv = document.createElement('div');
        lightboxContentSmallDIv.className = 'lightbox-content-div';

        var lightboxImage = document.createElement('img');
        lightboxImage.className = 'lightbox-image';
        var lightboxDivPTag = document.createElement('div');
        lightboxDivPTag.className = 'lightbox-div-p-tag';
        var lightboxImageText = document.createElement('p');

        var prevBtn = document.createElement('a');
        prevBtn.className = 'prev';

        var nextBtn = document.createElement('a');
        nextBtn.className = 'next';

        lightboxContentSmallDIv.appendChild(lightboxImage)
        lightboxContentSmallDIv.appendChild(lightboxDivPTag);
        lightboxDivPTag.appendChild(lightboxImageText);
        lightboxContent.appendChild(lightboxContentSmallDIv);
        lightboxContent.appendChild(prevBtn);
        lightboxContent.appendChild(nextBtn);
        lightboxContent.appendChild(closeBtn);
        lightbox.appendChild(lightboxContent);

        entryContent.appendChild(lightbox);

        var galleryItems = Array.from(document.querySelectorAll('.wp-block-column figure img'));

        galleryItems.sort(function(a, b) {
            if (a.parentElement.className.match(/img-(\d+)/) && b.parentElement.className.match(/img-(\d+)/)) {
                var numA = parseInt(a.parentElement.className.match(/img-(\d+)/)[1]);
                var numB = parseInt(b.parentElement.className.match(/img-(\d+)/)[1]);

                return numA - numB;
            }

        });
        var currentIndex = 0;

        function openLightbox(index) {
            currentIndex = index;
            lightboxImage.src = galleryItems[currentIndex].src;
            lightboxImageText.innerHTML = galleryItems[currentIndex].alt;
            lightbox.style.display = 'block';
            setTimeout(function() {
                lightboxImage.classList.add('show');
            }, 10);
            document.addEventListener('keydown', handleKeydown); // Dodaj nasłuchiwanie klawiszy
        }

        function closeLightbox() {
            lightbox.style.display = 'none';
            lightboxImage.classList.remove('show');
            document.removeEventListener('keydown', handleKeydown); // Usuń nasłuchiwanie klawiszy po zamknięciu
        }

        function showImage() {
            lightboxImage.classList.remove('show');  // Ukryj obecny obraz
            setTimeout(function() {
                lightboxImage.src = galleryItems[currentIndex].src;
                lightboxImageText.innerHTML = galleryItems[currentIndex].alt;
                lightboxImage.classList.add('show');  // Wyświetl nowy obraz z efektem fade
            }, 200);
        }

        function showNext() {
            currentIndex = (currentIndex + 1) % galleryItems.length;
            showImage();
        }

        function showPrev() {
            currentIndex = (currentIndex - 1 + galleryItems.length) % galleryItems.length;
            showImage();
        }

        function handleKeydown(event) {
            if (event.key === 'Escape') {
                closeLightbox();
            } else if (event.key === 'ArrowRight') {
                showNext();
            } else if (event.key === 'ArrowLeft') {
                showPrev();
            }
        }

        galleryItems.forEach(function(item, index) {
            item.addEventListener('click', function() {
                openLightbox(index);
            });
        });

        closeBtn.addEventListener('click', closeLightbox);
        nextBtn.addEventListener('click', showNext);
        prevBtn.addEventListener('click', showPrev);

        lightbox.addEventListener('click', function(event) {
            if (event.target === lightbox) {
                closeLightbox();
            }
        });
    };
})